import { FC, SVGProps } from 'react';
import { SvgIcon } from '../SvgIcon';

export const XIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
	return (
		<SvgIcon viewBox='0 0 12 12' fill='none' {...props}>
			<path
				fill='currentColor'
				fillRule='evenodd'
				d='m12.228 1.202-.974-.974-5.026 5.025L1.202.228l-.974.974 5.026 5.026-5.026 5.025.974.974 5.026-5.024 5.026 5.024.974-.974-5.026-5.025 5.026-5.026Z'
				clipRule='evenodd'
			/>
		</SvgIcon>
	);
};

export function XIconNew(props: React.ComponentProps<'svg'>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='M18 6 6 18' />
			<path d='m6 6 12 12' />
		</svg>
	);
}
